<template>
  <div>
    <!-- Drawer抽屉 -->
    <Drawer :title="title" v-model="visible" width="720" draggable>
      <div :style="{maxHeight: maxHeight}" class="drawer-content">
        <Form ref="form" :model="form" :rules="formValidate" label-position="top">
          <div class="drawer-header">
            <div style="margin-right: 16px">关联信息</div>
          </div>
           <Row :gutter="32">
            <Col span="12">
              <FormItem label="设备" prop="deviceName">
                <Input v-model="form.deviceName" readonly disabled></Input>
              </FormItem>
            </Col>
            <Col span="12">
              <FormItem label="机构" prop="orgName">
                <Input v-model="form.orgName" readonly disabled></Input>
              </FormItem>
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
            <FormItem label="过期时间" prop="expireTime">
              <Input v-model="form.expireTime" readonly disabled></Input>
            </FormItem>
            </Col>
          </Row>

          <div class="drawer-header">
            <div style="margin-right: 16px; margin-top: 16px">权限信息</div>
          </div>
          <Row :gutter="32">
            <Col span="12"> 
            <div class="drawer-function">基本属性</div>                         
            </Col>
             <Col span="12">
             <div class="drawer-function">扩展属性</div>          
            </Col>
          </Row>
          <Row :gutter="32">
            <Col span="12">
            <div style="position: relative">
              <Tree
                ref="tree"
                :data="permData"
                :check-strictly="!strict"
                show-checkbox
              ></Tree>
              <Spin size="large" fix v-if="treeLoading"></Spin>
            </div>
            </Col>
             <Col span="12">
            <div style="position: relative">
              <Tree
                ref="extendTree"               
                :data="extendPermData"
                :check-strictly="!strict"
                show-checkbox
              ></Tree>
              <Spin size="large" fix v-if="extendTreeLoading"></Spin>
            </div>
            </Col>
          </Row>
          <div style="height:200px">
          </div>        
        </Form>
      </div>
    </Drawer>
  </div>
</template>

<script>
// import dict from "@/views/my-components/jmbase/dict";

let dict  = window.jinmabasecomponents.components.dict;

import { getDeviceList, getOrgList, getOrgTypePermissionList } from "@/api/index"

export default {
  name: "addEdit",
  components: {
    dict,
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object
    },
    type: {
      type: String,
      default: "0"
    }
  },
  data() {
    return {    
      strict: true,
      treeLoading: true,
      extendTreeLoading: true,
      permData: [],
      extendPermData: [],
      deviceList: [],
      orgList: [],
      visible: this.value,
      title: "",
      submitLoading: false,
      maxHeight: 510,
      form: { // 添加或编辑表单对象初始化数据
        deviceName: "",
        deviceId: "",
        expireTime: "",        
        orgId: "",
        orgName: "",      
      },
      // 表单验证规则
      formValidate: {
        deviceId: [{required: true, message: "不能为空", trigger: "change"}],
        // deviceName: [{required: true, message: "不能为空", trigger: "change"}],
        orgId: [{required: true, message: "不能为空", trigger: "change"}],
        // orgName: [{required: true, message: "不能为空", trigger: "change"}],
      }
    };
  },
  methods: {
    // 递归子节点 取消所有钩
    unCheckPermTree(permData) {
      let that = this;
      permData.forEach(function (p) {        
        p.checked = false;    
        p.indeterminate = false;//清除半选状态      
        if (p.children && p.children.length > 0) {
          that.unCheckPermTree(p.children);
        }
      });
    },
    checkPermTree(inputData, extContent) {
      inputData.forEach( p => {
        if (p.children && p.children.length > 0) {
          this.checkPermTree(p.children, extContent);
        }else{
          if (this.hasPerm(p, extContent) && p.status != -1) {
            p.checked = true;
          } else {
            p.checked = false;
          }
        }
      });
    },

    // 禁用子节点
    disablePermTree(permData, rolePerms) {
      let that = this;
      permData.forEach(function (p) {
        p.disabled = true        
        if (p.children && p.children.length > 0) {
          that.disablePermTree(p.children, rolePerms);
        }
      });
    },

    // checkPermTree(retData, inputData, extContent) {
    //   inputData.forEach( p => {
    //     if (this.hasPerm(p, extContent) && p.status != -1) {
    //       retData.push(p);
    //     }
    //     if (this.children && p.children.length > 0) {
    //       retData.children = [];
    //       this.checkPermTree(retData.children,p.children, extContent);
    //     }
    //   });
    // },
    hasPerm(p,extContent) {
      return extContent.has(p.id) 
    },
    getPermExtContent() {
      let extContent = new Map();      
      if (this.form.extContent != null && this.form.extContent.length > 0) {
        let extContentList = JSON.parse(this.form.extContent);
          for (let k of extContentList) {
            let arr = k.permissionIds.split(",");
            for(let id of arr) {
              extContent.set(id,k.functionType);
            }
          }
        } 
        console.log(extContent);
        return extContent;
      },
    deleteDisableNode(permData) {
      let that = this;
      permData.forEach(function (e) {
        if (e.status == -1) {
          e.title = "[已禁用] " + e.title;
          e.disabled = true;
        }
        if (e.children && e.children.length > 0) {
          that.deleteDisableNode(e.children);
        }
      });
    },
    getPermList(orgtype) {
      this.treeLoading = true;
      let queryParam = {
        orgType: orgtype,
        functionType: 1,
      }
      getOrgTypePermissionList(queryParam).then((res) => {
        if (res.success) {
          this.deleteDisableNode(res.result);
          this.permData = res.result;
          let extContent = this.getPermExtContent();
         // let retData = [];
         this.unCheckPermTree(this.permData);
          this.checkPermTree(/*retData,*/this.permData,extContent);
          this.disablePermTree(this.permData,extContent);
        //  this.permData = retData;
          this.treeLoading = false;
        }
        this.treeLoading = false;
      });
    },
    getExtendPermList(orgtype) {
      this.extendTreeLoading = true;
      let queryParam = {
        orgType: orgtype,
        functionType: 2,
      }
      getOrgTypePermissionList(queryParam).then((res) => {
        if (res.success) {
          this.deleteDisableNode(res.result);
          this.extendPermData = res.result;
          if (this.form.extContent != null && this.form.extContent.length > 0) {
          let extContent = this.getPermExtContent();
          this.unCheckPermTree(this.extendPermData);
        //  let retData = [];
          this.checkPermTree(/*retData, */this.extendPermData,extContent);
          this.disablePermTree(this.extendPermData,extContent);
        //  this.extendPermData = retData;
          this.extendTreeLoading = false;
	  }
        }
        this.extendTreeLoading = false;
      });
    },
    init() {
    },
    setCurrentValue(value) {
      if (value === this.visible) {
        return;
      }
      if (this.type == "1") {
        this.title = "编辑";
        this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
      } else if (this.type == "2") {
        this.title = "添加";
        this.maxHeight =
            Number(document.documentElement.clientHeight - 121) + "px";
      } else {
        this.title = "详细信息";
        this.maxHeight = "100%";
      }
      // 清空数据
      this.$refs.form.resetFields();
      this.form = this.data;
      this.visible = value;
      this.orgList = this.data.orgList;
      this.deviceList = this.data.deviceList;
      
      if (this.form.orgId != null) {
            let orgInfo = this.orgList.filter(x=> x.id == this.form.orgId);
            this.getPermList(orgInfo[0].organizationType);
            this.getExtendPermList(orgInfo[0].organizationType);
      }

      // let searchParam = {
      //   pageNumber: 1,
      //   pageSize: 1000      
      // }
      // getOrgList(searchParam).then(res => {
      //   if (res.success) {
      //     this.orgList = res.result.records
      //     if (this.form.orgId != null) {
      //       let orgInfo = this.orgList.filter(x=> x.id == this.form.orgId);
      //       this.getPermList(orgInfo[0].organizationType);
      //       this.getExtendPermList(orgInfo[0].organizationType);
      //     }
      //   }
      // });
      // getDeviceList(searchParam).then(res => {
      //   if (res.success) {
      //     this.deviceList = res.result.records
      //   }
      // });
    }
  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    },
    visible(value) {
      this.$emit("input", value);
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="less">
// 建议引入通用样式 具体路径自行修改 可删除下面样式代码
// @import "@/styles/drawer-common.less";
.drawer-footer {
  z-index: 10;
  width: 100%;
  position: absolute;
  bottom: 0;
  left: 0;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: left;
  background: #fff;
}

.drawer-content {
  overflow: auto;
}

.drawer-content::-webkit-scrollbar {
  display: none;
}

.drawer-header {
  display: flex;
  align-items: center;
  margin-bottom: 16px;
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.drawer-title {
  font-size: 16px;
  color: rgba(0, 0, 0, 0.85);
  display: block;
  margin-bottom: 16px;
}
.drawer-function {
  text-align: center;
  padding-top: 5px;
  height: 30px;
  width: 100%;
  background: rgb(248, 248, 248);
}
</style>
